import { useState } from 'react'
import { Message } from 'semantic-ui-react'

import RequestService from 'services/request.service'

import Input from 'components/formElements/SemanticInput'
import SimpleSpinner from 'components/elements/SimpleSpinner'
import SimplePageWrapper from 'components/misc/SimplePageWrapper'
import Image from 'components/elements/Image'
import PhatButton from 'components/formElements/PhatButton'

import styles from './forgotPassword.module.scss'

const LoginPage = () => {
  const [loading, setLoading] = useState(false)
  const [submitStatus, setSubmitStatus] = useState('')
  const [email, setEmail] = useState('')

  const handlePasswordReset = (e: React.SyntheticEvent) => {
    e.preventDefault()

    setLoading(true)
    setSubmitStatus('')

    RequestService.post('/api/rest-auth/password/reset/', { email })
      .then(data => {
        if (data.detail) setSubmitStatus('success')
        else {
          if (data.email) setSubmitStatus(data.email[0])
          else setSubmitStatus('Email submit failed')
        }
      })
      .finally(() => setLoading(false))
  }

  return (
    <SimplePageWrapper title="Forgot password" robots="noindex">
      <div className={styles.branding}>
        <Image alt="Archidekt basic logo" src="/images/archidekt_basic.svg" height={100} />
        Archidekt password reset
      </div>
      <form className={styles.form} onSubmit={handlePasswordReset}>
        <div>
          <label>Please enter account email:</label>
          <Input name="email" placeholder="Email" type="email" onChange={setEmail} focusOnMount />
        </div>

        <PhatButton disabled={loading} type="submit" color="green">
          {loading ? (
            <span className={styles.loading}>
              <SimpleSpinner size="xSmall" />
              Sending password reset
            </span>
          ) : (
            'Request password reset'
          )}
        </PhatButton>

        {submitStatus === 'success' && (
          <Message
            success
            header="Success"
            content="If an account with the supplied email exists, a password reset email has been sent.
            If you don't see it in your inbox, please check spam."
          />
        )}
        {submitStatus && submitStatus !== 'success' && <Message error header="Error" content={submitStatus} />}
      </form>
    </SimplePageWrapper>
  )
}

export default LoginPage
